// extracted by mini-css-extract-plugin
export default {"tableRoot":"ReactTable-module__tableRoot--OhJ8f","tableBodyContainer":"ReactTable-module__tableBodyContainer--aeYvr","fixedOmnibar":"ReactTable-module__fixedOmnibar--QBvCV"};